var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverViolation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1, .st2 {\n        fill: #d8b4fe;\n      }\n\n      .st3 {\n        fill: #6b21a8;\n      }\n\n      .st1, .st4, .st5, .st6, .st7 {\n        stroke: #6b21a8;\n      }\n\n      .st1, .st7 {\n        stroke-width: 45px;\n      }\n\n      .st8 {\n        fill: #a78bfa;\n      }\n\n      .st4 {\n        stroke-width: 30px;\n      }\n\n      .st4, .st9 {\n        stroke-linecap: round;\n      }\n\n      .st10, .st7 {\n        fill: #fff;\n      }\n\n      .st11, .st9 {\n        stroke: #d8b4fe;\n        stroke-width: 25px;\n      }\n\n      .st11, .st9, .st5, .st6 {\n        fill: none;\n      }\n\n      .st5 {\n        stroke-width: 35px;\n      }\n\n      .st6 {\n        stroke-width: 50px;\n      }\n\n      .st2 {\n        isolation: isolate;\n        opacity: .3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 268.35,
    y: 125,
    width: 600,
    height: 800,
    rx: 50,
    ry: 50
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 418.35,
    y: 75,
    width: 300,
    height: 100,
    rx: 30,
    ry: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "violation-list"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 348.35,
    y1: 275,
    x2: 688.35,
    y2: 275
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M728.35,255l40,40M768.35,255l-40,40"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 348.35,
    y1: 395,
    x2: 688.35,
    y2: 395
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M728.35,375l40,40M768.35,375l-40,40"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 348.35,
    y1: 515,
    x2: 688.35,
    y2: 515
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M728.35,495l40,40M768.35,495l-40,40"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 348.35,
    y1: 635,
    x2: 788.35,
    y2: 635
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 348.35,
    y1: 755,
    x2: 648.35,
    y2: 755
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "driver-main"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 268.35,
    cy: 412.83,
    r: 120
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 268.35,
    cy: 412.83,
    r: 100
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 268.35,
    cy: 610.33,
    rx: 228.92,
    ry: 140
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 268.35,
    cy: 610.33,
    rx: 206.59,
    ry: 120
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 268.35,
    cy: 732.83,
    r: 170
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 268.35,
    cy: 732.83,
    r: 122.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 268.35,
    cy: 742.83,
    r: 70
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 112.83,
    y1: 742.83,
    x2: 218.56,
    y2: 742.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 323.35,
    y1: 742.83,
    x2: 413.35,
    y2: 742.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 268.35,
    y1: 583.34,
    x2: 268.35,
    y2: 687.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 268.35,
    y1: 802.76,
    x2: 268.35,
    y2: 882.83
  })), /*#__PURE__*/React.createElement("g", {
    id: "warning-badge"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 269.35,
    cy: 748.02,
    r: 94.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 269.35,
    cy: 748.02,
    r: 83.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 260.44,
    y: 700.54,
    width: 17.81,
    height: 59.35,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 269.35,
    cy: 777.69,
    r: 11.87
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverViolation);
export default __webpack_public_path__ + "static/media/driverViolation.6336e5d6e0971fb56d1875dfdaecd896.svg";
export { ForwardRef as ReactComponent };